export default __webpack_public_path__ + "static/media/Major Rune Stone of the Chaos Agent (V).5de62ffa.jpg";